import { Action, AnyAction, applyMiddleware, compose, createStore, Store as ReduxStore } from "redux";
import { ActionLog, createActionLog } from "redux-action-log";
import thunk from "redux-thunk";
import ProductAnalyticsMiddleware from "src/store/productAnalyticsMiddleware";
import { ApplicationStore } from "src/store/types/state";
import * as actions from "./actions";
import dataService from "./dataService";
import garageManagement from "./garageManagement";
import dynamicGarageReporter from "./dynamicGarageReporters";
import reducer from "./reducers";

export { actions, ApplicationStore };

export type DispatchAsync<A extends Action = AnyAction> = <T extends A>(action: T) => Promise<void>;

export type Store<A extends Action = AnyAction> = {
    dispatch: DispatchAsync;
} & ReduxStore<ApplicationStore, A>;

export type GetState = Store["getState"];

const enableReduxDevTools =
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
// const composeEnhancers = (enableReduxDevTools && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const composeEnhancers =
    (enableReduxDevTools &&
        typeof (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === "function" &&
        (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 25 })) ||
    compose;

let store: Store;

export let actionLog: ActionLog<any, AnyAction>;

const fillStore = (initialState: any): Store => {
    actionLog = createActionLog({ limit: 15 });

    store = createStore(
        reducer,
        initialState,
        composeEnhancers(
            applyMiddleware(dataService, ProductAnalyticsMiddleware, dynamicGarageReporter, garageManagement, thunk),
            actionLog.enhancer
        )
    );

    return store;
};

export default fillStore;

export function getStore() {
    return store;
}

export function getAppState() {
    return store && store.getState();
}
